module.exports = __webpack_public_path__ + "static/img/AccountManagement.be616a09.svg";